import React, { Fragment, useCallback, useEffect, useMemo, useState } from "react";
import { ModalLabels, RegisterLabels } from "../../assets/labels/labels";
import { IconCheck, IconClient } from "../../assets/svgs-index";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import PoweredBy from "../../components/PoweredBy/PoweredBy";
import { AuthenticationService } from "../../core/services/authentication.service";
import ModalInformation from "../../components/Modals/ModalInformation";
import { Helper, HelperConfig, HelperWebView } from "../../core/services/helper/helper.service";
import Cookies from "universal-cookie";
import { CompanyService } from "../../core/services/company.service";

const ReceiveConfirmEmail: React.FC<any> = () => {
  const { token } = useParams();
  const cookies = useMemo(() => new Cookies(), []);
  const location = useLocation();
  const navigate = useNavigate();

  const searchParams = new URLSearchParams(location.search);
  const email = searchParams.get("email") || location?.state?.email ||  "";
  const phone = searchParams.get("phone") || location?.state?.phone ||  "";
  const domain = searchParams.get("domain");
  const userid = searchParams.get("userid");
  const worktoken = searchParams.get("worktoken");
  const workemailtemp = searchParams.get("workemail");
  const workphonetemp = searchParams.get("workphone");
  const openAppointment = searchParams.get("openAppointment");
  const isCalToken = searchParams.get("isCalToken");
  const isEmbedded = Helper.isEmbedded();

  let workemail: string | undefined; 
  if (workemailtemp && workemailtemp !== "null" && workemailtemp !== "undefined" && workemailtemp !== "") {
    workemail =  workemailtemp;
  } 

  let workphone: string | undefined; 
  if (workphonetemp && workphonetemp !== "null" && workphonetemp !== "undefined" && workphonetemp !== "") {
    workphone =  workphonetemp;
  } 

  const [message, setMessage] = useState<string>("A confirmar o seu email..");

  if (userid) {
    cookies.set("userId", searchParams.get("userid"), HelperConfig.cookiesLiteConfig);
  }

  if (worktoken) {
    cookies.set("liteToken", searchParams.get("worktoken"), HelperConfig.cookiesLiteConfig);
  }

  if (workemail) {
    cookies.set("liteEmail", searchParams.get("workemail"), HelperConfig.cookiesLiteConfig);
  }

  if (workphone) {
    cookies.set("litePhone", searchParams.get("workphone"), HelperConfig.cookiesLiteConfig);
  }

  if (domain && !domain.includes("asuaempresa")) {
    const domainValue = (HelperConfig.isQAenvironment() && !domain.includes('.qa')) ? `${domain}.qa` : domain;
    cookies.set("kssreturncompany", domainValue, HelperConfig.cookiesLiteConfig);
  }

  if (openAppointment) {
    cookies.set("openAppointment", searchParams.get("openAppointment"), HelperConfig.cookiesLiteConfig);
  }

  if (isCalToken) {
    cookies.set("isCalToken", searchParams.get("isCalToken"), HelperConfig.cookiesLiteConfig);
  }

  const [modalInfoIsOpen, setModalInfoIsOpen] = useState<boolean>(false);
  const [modalInfoTitle, setModalInfoTitle] = useState<string>("");
  const [modalInfoMessage, setModalInfoMessage] = useState<string>("");
  const [modalInfoSubMessage, setModalInfoSubMessage] = useState<string>("");
  const [modalInfoConfirmText, setModalInfoConfirmText] = useState<string>("");
  const [modalInfoOnConfirm, setModalInfoOnConfirm] = useState<() => void>();

  const renderModalInformation = (handler: any) => {
    if (!modalInfoIsOpen) {
      return <Fragment />;
    }
    return (
      <ModalInformation
        modalIsOpen={modalInfoIsOpen}
        title={modalInfoTitle}
        message={modalInfoMessage}
        subMessage={modalInfoSubMessage}
        confirmText={modalInfoConfirmText}
        onClose={() => closeModal}
        onConfirm={handler || closeModal}
      />
    );
  };

  const closeModal = () => {
    setModalInfoIsOpen(false);
    setModalInfoTitle("");
    setModalInfoMessage("");
    setModalInfoSubMessage("");
    setModalInfoConfirmText("");
    setModalInfoOnConfirm(undefined);
  };

  const goToLoginCallback = useCallback(() => {
    closeModal();
    const goToLogin = () => {
      const path = `/login${isEmbedded ? '?embedded=true' : ''}`;
      navigate(path);
    };

    goToLogin();
    // eslint-disable-next-line 
  }, [navigate]);

  const renderModalGenericErrorCallback = useCallback(() => {
    const renderModalGenericError = () => {
      setModalInfoTitle(ModalLabels.genericErrorTitle);
      setModalInfoMessage(ModalLabels.genericErrorMessage);
      setModalInfoSubMessage("");
      setModalInfoConfirmText("Ok");
      setModalInfoOnConfirm(() => goToLoginCallback);
      setModalInfoIsOpen(true);
    };

    renderModalGenericError();
  }, [
    setModalInfoTitle,
    setModalInfoMessage,
    setModalInfoSubMessage,
    setModalInfoConfirmText,
    setModalInfoOnConfirm,
    setModalInfoIsOpen,
    goToLoginCallback,
  ]);

  const renderModalInvalidTokenCallback = useCallback(() => {
    const renderModalInvalidToken = () => {
      setModalInfoTitle("Link de Confirmação Inválido");
      setModalInfoMessage("O link de confirmação recebido é inválido");
      setModalInfoSubMessage("");
      setModalInfoConfirmText("Ok");
      setModalInfoOnConfirm(() => goToLoginCallback);
      setModalInfoIsOpen(true);
    };

    renderModalInvalidToken();
  }, [
    setModalInfoTitle,
    setModalInfoMessage,
    setModalInfoSubMessage,
    setModalInfoConfirmText,
    setModalInfoOnConfirm,
    setModalInfoIsOpen,
    goToLoginCallback,
  ]);

  const submitEmailConfirmationCallback = useCallback(() => {
    const submitEmailConfirmation = () => {
      if (token) {
        let params = '';
        if (userid) {
          params = `&userid=${userid}`;
        }
        if (worktoken) {
          params += `&worktoken=${worktoken}`;
        }
        if (domain) {
          params += `&domain=${domain}`;
        }
        if (openAppointment) {
          params += `&openAppointment=${openAppointment}`;
        }
        if (workemail) {
          params += `&workemail=${encodeURIComponent(workemail)}`;
        }
        if (workphone) {
          params += `&workphone=${encodeURIComponent(workphone)}`;
        }
        if (email) {
          params += `&email=${encodeURIComponent(email)}`;
        }
        if (phone) {
          params += `&phone=${encodeURIComponent(phone)}`;
        }
        if (isCalToken) {
          params += `&isCalToken=${isCalToken}`;
        }
        if (isEmbedded) {
          params += `&embedded=${isEmbedded}`;
        }
        AuthenticationService.submitEmailConfirmation(token, params).then((res) => {
          if (!res?.modal) {
            if (res.tokenError) {
              if (res?.code === 0) {
                setMessage("Ocorreu um problema com o registo do seu e-mail. \nTente novamente pf.");
                const path = '/registo';
                setTimeout(() => { navigate(`${path}${isEmbedded ? '?embedded=true' : ''}`, { state: { email } }); }, 5000);
              }
              if (res?.code === 1) {
                setMessage("O e-mail foi confirmado com sucesso anteriormente. \nInicie sessão no próximo ecra.");
                const path = '/login';
                setTimeout(() => { navigate(`${path}${isEmbedded ? '?embedded=true' : ''}`, { state: { email } }); }, 5000);
              }
              if (res?.code === 2) {
                res?.path &&
                  //navigate(res.path, { state: { email, isTokenError: res.tokenError } });
                  navigate(`${res.path}${isEmbedded ? '?embedded=true' : ''}`, { state: { email, isTokenError: res.tokenError } });
              }
            } else {
              if (res.token) {
                const eventInfo = {
                  auth_token: res.token,
                  route: cookies.get("route"),
                  client_route: cookies.get("clientroute")
                };
                if (HelperWebView.isIOSWebview()) {
                  try {
                    (window as any).webkit.messageHandlers.login.postMessage(eventInfo);
                  } catch (error) {
                    console.error(error);
                  }
                }
                if (HelperWebView.isAndroidWebview()) {
                  try {
                    (window as any).Android.login(
                      eventInfo.auth_token,
                      eventInfo.route,
                      eventInfo.client_route
                    );
                  } catch (error) {
                    console.error(error);
                  }
                }
                Helper.setCookie('sessionToken', res.token);
                AuthenticationService.handleAuthRedirect((res as any).res?.data, navigate);

              }
              if (!(res as any).res?.data){
                renderModalGenericErrorCallback();
              }
            }
          } else {
            renderModalGenericErrorCallback();
          }
        });
      } else {
        renderModalInvalidTokenCallback();
      }
    };

    submitEmailConfirmation();
    // eslint-disable-next-line 
  }, [
    email,
    token,
    domain,
    userid,
    worktoken,
    openAppointment,
    workemail,
    workphone,
    isCalToken,
    navigate,
    setMessage,
    renderModalGenericErrorCallback,
    renderModalInvalidTokenCallback,
  ]);

  useEffect(() => {
    submitEmailConfirmationCallback();
  }, [submitEmailConfirmationCallback]);


  const renderEmbeddedHeader = () => {
    return (
      <>
        <div className="header w-100 d-flex flex-row justify-content-between ps-md-9 opacity-50">
          <div className="logo-container d-flex flex-column">
            <div className="company-logo mt-2 mx-3 mx-md-4">
              <img className="kmclient-logo"
              src={domain ? CompanyService.urlCompanyImage(`domain/${domain}`) : IconClient}
              alt="logo"
              onError={(e) => ((e.target as HTMLImageElement).src = IconClient)} />
            </div>
          </div>
          <div className="app-logo-container me-3 me-md-4 align-items-center">
            {" "}
            <PoweredBy isTop={true}/>
          </div>
        </div>
      </>
    )
  }

  const containerStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: 'rgba(0, 0, 0, 0.7)', // semi-transparent background
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    zIndex: 1000, // Ensure it's on top of other elements
    maxWidth: 'none',

  };

  const iframeContainerStyle = {
    width: '96%',
    height: '200%',
    backgroundColor: '#fff',
    borderRadius: '8px',
    //overflow: 'hidden',
    boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
    position: 'relative',
  };

  const embeddedContainerStyle = isEmbedded ? containerStyle : {};
  const embeddedIframeContainerStyle = isEmbedded ? iframeContainerStyle : {};


  return (
    <React.Fragment>
      <div className={`main-page-container pb-4 h-100 pt-0 align-center justify-content-start ${isEmbedded ? 'mt-0 ' : 'mt-4 container'}`} style={embeddedContainerStyle}>
        {!isEmbedded &&
          <>
            <div className="company-logo-container mt-2 mt-md-4" onClick={() => navigate("/")}>
              <img className="kmclient-logo" src={IconClient} alt="logo" />
            </div>
          </>
        }
        {isEmbedded && renderEmbeddedHeader()}
        {isEmbedded ? (
          <div style={embeddedIframeContainerStyle}>

            <h3 className="text-center w-100 my-4">{RegisterLabels.sendConfirmEmailInfo.header}</h3>

            <div className="grey-box-container align-center py-4 px-6 w-100">
              <div className="text-center message-container mt-4">{message}</div>
              <div className="check-icon-container mt-5 mb-2">
                <img src={IconCheck} alt="icon-check" />
              </div>
            </div>
            <div className="powered-by-container mt-4 w-100">
              {" "}
              <PoweredBy />
            </div>
            {renderModalInformation(modalInfoOnConfirm)}
          </div>)
          :
          (<>
            <h3 className="text-center w-100 my-4">{RegisterLabels.sendConfirmEmailInfo.header}</h3>

            <div className="grey-box-container align-center py-4 px-6 w-100">
              <div className="text-center message-container mt-4">{message}</div>
              <div className="check-icon-container mt-5 mb-2">
                <img src={IconCheck} alt="icon-check" />
              </div>
            </div>
            <div className="powered-by-container mt-4 w-100">
              {" "}
              <PoweredBy />
            </div>
            {renderModalInformation(modalInfoOnConfirm)}
          </>)
        }


      </div>
    </React.Fragment>
  );
};

export default ReceiveConfirmEmail;
